<!--
  ~ Copyright 2015-2023 Ritense BV, the Netherlands.
  ~
  ~ Licensed under EUPL, Version 1.2 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" basis,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<v-paragraph [margin]="true"
             [italic]="true">
  {{ 'executeActionInformation' | pluginTranslate : pluginId | async }}
</v-paragraph>
<v-form (valueChange)="formValueChange($event)"
        *ngIf="{
    disabled: disabled$ | async,
    prefill: prefillConfiguration$ ? (prefillConfiguration$ | async) : null
  } as obs">
  <ng-container *ngIf="{actionDefinitionSelectItems: actionDefinitionSelectItems$ | async} as vars">
    <v-select [items]="vars.actionDefinitionSelectItems"
              [margin]="true"
              [widthInPx]="350"
              name="actionDefinitionId"
              [title]="'actionDefinitionId' | pluginTranslate : pluginId | async"
              [disabled]="obs.disabled"
              [defaultSelectionId]="obs.prefill?.actionDefinitionId"
              [required]="true"
              [loading]="!vars.actionDefinitionSelectItems"
              [tooltip]="'actionDefinitionIdTooltip' | pluginTranslate : pluginId | async"></v-select>
  </ng-container>
  <v-input name="targetId"
           [title]="'targetId' | pluginTranslate : pluginId | async"
           [margin]="true"
           [defaultValue]="obs.prefill?.targetId"
           [disabled]="obs.disabled"
           [required]="false"
           [tooltip]="'targetIdTooltip' | pluginTranslate : pluginId | async"
           [fullWidth]="true">
  </v-input>
  <v-input name="actionParameters"
           [title]="'actionParameters' | pluginTranslate : pluginId | async"
           [margin]="true"
           [defaultValue]="obs.prefill?.actionParameters"
           [disabled]="obs.disabled"
           [required]="true"
           [tooltip]="'actionParametersTooltip' | pluginTranslate : pluginId | async"
           [fullWidth]="true">
  </v-input>
</v-form>